import React from 'react';
import { withLocalize } from "react-localize-redux";

class NotAuthorizedComponent extends React.Component {
    render() { 
        return (<div>Not authorized</div>)
    }
}
export default withLocalize(NotAuthorizedComponent);
